//import * as React from 'react';
import React, { useState } from 'react';

import { ThemeProvider } from '@material-ui/core/styles';
import { MainContainer, Header, Footer, Theme, CookieBanner } from '@ktr/ktr-materialui-react';
import Body from './components/Body/Body';
import { CssBaseline } from '@material-ui/core';

import { useTranslation } from 'react-i18next';

import Configuration from './config/Config';

// Google Anlytics
//import ReactGA from 'react-ga';
//import { gaInit } from './service/ServiceAPI';

//import CookieBanner from './components/CookieBanner/CookieBanner';


// ------------------------------------------------------------------------------------
interface AppProps {
  title?: string,
  description?: string,
}

interface Language {
  langCode: string,
  language: string
}

const languages: Array<Language> = [
  {
    langCode: "de",
    language: "Deutsch"
  },
  {
    langCode: "en",
    language: "English"
  },
  {
    langCode: "es",
    language: "Español"
  }

];


//const App : React.FC = () => {
const App = (props: AppProps) => {
  const { t, i18n } = useTranslation();
  
  let cookiename = Configuration.cookiename;

  // we take the current i18next language and initialize the state accordingly (so the header-language-selection is up-to-date)
  let idxLang = 0;
  switch (i18n.language) {
    case 'de':
      idxLang = 0;
      break;
    case 'en':
      idxLang = 1;
      break;  
    case 'es':
      idxLang = 2;
      break;
      default:
      idxLang = 1;
  }

  /*
  if(i18n.language === 'de')
    idxLang = 0;
  else if(i18n.language === 'es')
    idxLang = 2;
  else
    idxLang = 1;
  */

  const [currentLanguage, setCurrentLanguage] = useState<Language>(languages[idxLang]);

  // -----------------
  // Google Analytics:
  //gaInit(cookiename);   // GA is dynamically initialized in gaEvent !!!
  //ReactGA.initialize('UA-65129143-4', {debug: false});
  //ReactGA.pageview('/watercooler');  

  //ReactGA.

  // language
  function changeSelectedLanguage(lang: Language) {
    setCurrentLanguage(lang);
    i18n.changeLanguage(lang.langCode);  // ATTENTION: the string passed to changeLanguage is case-sensitive, e.g. 'en' works, but 'EN' does NOT  !!!
  }

  return (
    <ThemeProvider theme={Theme.whiteKTRTheme}>
      <CssBaseline />
        {/*<React.Fragment>*/}
          <Header
            showLanguageChanger={true}
            languages={languages}
            languageHelperText= {t('textselectlanguage')}
            getLanguageLabel={(lang: Language) => { return lang.language }}
            getLanguageValue={(lang: Language) => { return lang.langCode }}
            getLanguageSelected={(lang: Language) => { return lang === currentLanguage }}
            getCurrentLanguage={() => { return currentLanguage.language }}
            onLangChange={ (lang: Language) => { changeSelectedLanguage(lang) }}
            hyperlinkLogo="https://otools.ktr.com"
          />
          <MainContainer>

            <CookieBanner.default 
              cookiename={cookiename} 
              language={ currentLanguage.langCode === 'es' ? 'en' : currentLanguage.langCode }
              googleAnalytics={
                {
                  googleAnalytics: true,
                  googleAnalyticsPagePath: "/watercooler"
                } as CookieBanner.AnalyticsSettings
              } //
              salesViewer={true} //if you want to integrate salesviewer
            />

{/*            <SalesViewer></SalesViewer>   */}
            <Body></Body>
          </MainContainer>
          <Footer></Footer>
        {/*</React.Fragment>*/}
    </ThemeProvider>        
  );

};

export default App;
